import {
  useSuspenseQuery,
  UseQueryOptions,
  QueryFunctionContext,
  useQueryClient,
  QueryClient,
} from '@tanstack/react-query';

function createSuspenseQueryHook<QueryFnData, Params = void>(
  getQueryKey: (params: Params) => readonly unknown[],
  queryFn: (
    params: Params,
    context: QueryFunctionContext & { queryClient: QueryClient }
  ) => Promise<QueryFnData>
) {
  return <Data = QueryFnData>(
    params: Params,
    options?: Omit<
      UseQueryOptions<QueryFnData, unknown, Data>,
      'queryKey' | 'queryFn'
    >
  ) => {
    const queryClient = useQueryClient();
    return useSuspenseQuery<QueryFnData, unknown, Data>({
      queryKey: getQueryKey(params),
      queryFn: ctx => queryFn(params, { ...ctx, queryClient }),
      ...options,
    });
  };
}

export { createSuspenseQueryHook };
